import { fetchGet, fetchPost } from './fetch';

const API_URL = `/api/v1/payment`;

interface SetupStripeIntentRequest {}

interface SetupStripeIntentResponse {
  data?: {
    client_secret: string;
    payment_id: string;
  };
}
export const setupStripeIntent = async (req?: SetupStripeIntentRequest): Promise<SetupStripeIntentResponse | null> => {
  const url = `${API_URL}/setup_intent`;
  return fetchPost<SetupStripeIntentRequest, SetupStripeIntentResponse>(url, req);
};

export interface PaymentMethodDto {
  id: string;
  is_default: boolean;
  exp_month?: number;
  exp_year?: number;
  last4?: string;
  brand?: `amex` | `diners` | `discover` | `jcb` | `mastercard` | `unionpay` | `visa` | `unknown`;
  funding: `credit` | `debit` | `prepaid` | `unknown`;
}
export interface GetPaymentMethodDetailResponse {
  data: PaymentMethodDto[];
}

export const getPaymentMethodDetail = async (): Promise<GetPaymentMethodDetailResponse> => {
  const url = `/api/v1/organization/payment_method_detail`;
  return fetchGet<GetPaymentMethodDetailResponse>(url);
};
interface GetDownloadInvoiceLink {
  data: {
    url?: string;
  };
}

export const getDownloadInvoiceLink = async (id: number): Promise<GetDownloadInvoiceLink> => {
  const url = `/api/v1/organization/invoice_pdf/${id}`;
  return fetchGet<GetDownloadInvoiceLink>(url);
};
